<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 10v6M2 10l10-5 10 5-10 5-10-5zM6 12v5c0 1.66 2.69 3 6 3s6-1.34 6-3v-5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
